import React, { FC } from "react";

interface ButtonProps {
  title: any;
  onClick: any;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
}

const Button: FC<ButtonProps> = ({ title, onClick, className, isLoading, type = "button", disabled = false }) => {
  return (
    <button type={type} disabled={disabled} className={`bg-polifyx-gradient h-12 rounded-md md:rounded-3xl w-full mx-4 md:w-52 font-bold flex items-center justify-center gap-3 ${isLoading && "opacity-50 pointer-events-none"} ${className}`} onClick={onClick}>
      {isLoading && <div className="w-4 h-4 border-[2px] border-t-[#dea15c] rounded-full animate-spin"></div>}
      <p>{title}</p>
    </button>
  );
};

export default Button;
